import { FaThermometerThreeQuarters } from 'react-icons/fa';

const FleetHealthStatus = () => {
  const healthyPct = 35;
  const health = getHealthStatus(healthyPct);

  return (
    <div className="fleet-health-card">
      <div className="header">
        <h3>
          <FaThermometerThreeQuarters color='#3343ea85' />

          Fleet Health Status
        </h3>
        <i className="fas fa-info-circle info-icon" title="Info"></i>
      </div>

      <div className="circle-wrapper">
        <div className="donut-chart">
          <svg viewBox="0 0 42 42" className="donut">
            <circle
              className="donut-ring"
              cx="21"
              cy="21"
              r="15.9155"
              fill="transparent"
              stroke="#e5e7eb"
              strokeWidth="4"
            />
            <circle
              className="donut-segment"
              cx="21"
              cy="21"
              r="15.9155"
              fill="transparent"
              stroke={health.color}
              strokeWidth="4"
              strokeDasharray={`${healthyPct} ${100 - healthyPct}`}
              strokeDashoffset="25"
            />
          </svg>
          <div className="center-label">
            <div className="percent">{healthyPct}%</div>
            <div className="text">Healthy</div>
          </div>
        </div>
        <div className={`status-label ${health.textClass}`}>{health.label}</div>
      </div>

      <div className="legend">
        <div className="legend-item">
          <span className="dot" style={{ background: '#f59e42' }}></span>
          <span>0–70% <strong>Poor</strong></span>
        </div>
        <div className="legend-item">
          <span className="dot" style={{ background: '#3b82f6' }}></span>
          <span>70–90% <strong>Normal</strong></span>
        </div>
        <div className="legend-item">
          <span className="dot" style={{ background: '#22c55e' }}></span>
          <span>90%+ <strong>Good</strong></span>
        </div>
      </div>
    </div>
  );
};

const getHealthStatus = (pct) => {
  if (pct >= 90) return { label: 'Good', color: '#22c55e', textClass: 'good' };
  if (pct >= 70) return { label: 'Normal', color: '#3b82f6', textClass: 'normal' };
  return { label: 'Poor', color: '#f97316', textClass: 'poor' };
};

export default FleetHealthStatus;
